<template>
  <div class="container">
    <TheLayout><router-view /></TheLayout>
  </div>
</template>
<script>
import TheLayout from "./TheLayout";
export default {
  components: {
    TheLayout
  }
};
</script>
<style lang="less" scoped>
.container {
  height: 100%;
  width: 100%;
}
</style>
